import { useState } from 'react';
import cx from 'classnames';

import { StaticPanel } from 'src/components/StaticPanel';
import { useBooleanState } from 'src/lib/hooks/useBooleanState';

import { ImageOverlayTextControl } from './components/ImageOverlayTextControl';
import { OverlayMenu } from './components/OverlayMenu';
import { ImageOverlayTextForm } from './views/ImageOverlayTextForm';
import { useHandlers } from './useHandlers';
import { useStyles } from './useStyles';
import { useViewState } from './useViewState';

export const BlockImageOverlay = ({ className, classes, title, disabled }) => {
  const styles = useStyles({ classes });

  const [rootElement, setRootElement] = useState(null);
  const [menuOpened, openMenu, closeMenu] = useBooleanState(false);

  const { imageOverlayProperties } = useViewState();

  const { handleControlClick, handleMenuClose, handleSubmitForm } = useHandlers({
    openMenu,
    closeMenu,
  });

  return (
    <StaticPanel
      className={cx(styles.root, className)}
      classes={{ title: styles.title }}
      ref={setRootElement}
      title={title || 'Overlay text'}
    >
      <ImageOverlayTextControl
        imageOverlayProperties={imageOverlayProperties}
        onClick={handleControlClick}
        active={menuOpened}
        disabled={disabled}
      />

      <OverlayMenu
        referenceElement={rootElement}
        open={menuOpened}
        onClose={handleMenuClose}
      >
        <ImageOverlayTextForm
          initialData={imageOverlayProperties}
          onSubmit={handleSubmitForm}
          onCancel={handleMenuClose}
          disabled={disabled}
        />
      </OverlayMenu>
    </StaticPanel>
  );
};
